module.exports = __webpack_public_path__ + "5e6a28e42e95321bbe4fbc746de8638c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/thrift_savings_plan_2022_chart.png
// module id = 1749
// module chunks = 0